import { Box, Rating, Truncatable } from '@bridebook/ui';
import { IFeedbackSerialized } from '@bridebook/web/app-shared/lib/supplier/types';
import componentStyles from './review-card.style';
import { format } from '@bridebook/web/lib/i18n/utils/get-date-fns-format';

interface IProps {
  review: Partial<IFeedbackSerialized>;
  themeIndex: number;
}

const Swirl = () => (
  <svg width="297" height="190" viewBox="0 0 297 190" fill="none">
    <path
      d="M-4.96766 -33.0006C-14.298 62.4096 64.8997 -44.9668 95.2707 18.6611C126.775 84.6628 176.047 -5.59145 224.612 57.1319C253.884 109.696 277.485 236.174 299.583 135.016C327.205 8.56874 330.09 235.6 394.1 162.361"
      strokeWidth="24"
    />
  </svg>
);

const ReviewCard = ({ review, themeIndex }: IProps) => {
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper(themeIndex)}>
      <Box style={styles.content}>
        <Box style={styles.header}>
          <Box style={styles.avatar}>{review.name?.[0]}</Box>
          <Box>
            <Box>{review.name}</Box>
            <Box style={styles.ratingBox}>
              {review.stars && <Rating rating={review.stars} />}
              {review.createdAt && (
                <Box style={styles.date}>{format(new Date(review.createdAt), 'dd/MM/yyyy')}</Box>
              )}
            </Box>
          </Box>
        </Box>
        <Box style={styles.title}>
          <Truncatable text={review.title || ''} lineClamp={1} />
        </Box>
        <Box style={styles.body}>
          <Truncatable text={review.body || ''} lineClamp={8} />
        </Box>
      </Box>
      <Box style={styles.swirlBox}>
        <Swirl />
      </Box>
    </Box>
  );
};

export default ReviewCard;
